import {useContext} from 'react';
import {ChannelContext} from 'app/contexts';

const useChannelContext = () => useContext(ChannelContext);

export default useChannelContext;
